import angular from 'angular';
import addressComponent from './address.component';
import addressService from './address.service';
import addressConfig from './address.config';

let addressModule = angular.module('app.address',[])
    .component('address', addressComponent)
    .service('addressService', addressService)
    .config(addressConfig);

export default addressModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/address/address.js
 **/